"use client";

import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { useContext } from "timvir/context";
import * as Icons from "../../../../icons";
export function SidebarItem(props) {
  const {
    depth,
    label,
    path,
    children = [],
    active,
    setActive
  } = props;
  const {
    navigation
  } = useContext();
  const {
    Link,
    usePathname
  } = navigation;
  const pathname = usePathname();
  const iconStylexProps = {
    className: "x1iog12x xy77lq4 x1jpgh95 xcdlrvm x1l36t39 x1nslcl8"
  };
  const iconStyle = {
    ...iconStylexProps.style,
    transform: active ? "rotate(90deg)" : "rotate(0deg)"
  };
  const icon = children.length === 0 ? null : <Icons.ChevronRight className={iconStylexProps.className} style={iconStyle} width={16} height={16} />;
  const isActive = pathname === path;
  const linkStylexProps = {
    0: {
      className: "xeuugli xpau0pd x12oqio5 x78zum5 x6s0dn4 x1cdhzux xk50ysn xjbqb8w x1hl2dhg xh8yej3 x1xq1gxn x1ks1olk xc342km xdpxx8g x1ypdohk xjb2p0i x6u19be x1ylh3l6 xasi8qw x8kob5h x1dc5b4e x1o7uuvo"
    },
    1: {
      className: "xeuugli xpau0pd x12oqio5 x78zum5 x6s0dn4 x1cdhzux xk50ysn x1hl2dhg xh8yej3 x1xq1gxn xc342km xdpxx8g x1ypdohk xjb2p0i x6u19be x1ylh3l6 xasi8qw x8kob5h x1dc5b4e x1o7uuvo x6r7942 x1hc1fzr"
    }
  }[!!isActive << 0];
  const linkStyle = {
    ...linkStylexProps.style,
    marginLeft: depth * 16
  };
  return <div className="x78zum5 x6s0dn4 x3my8ay">
      {path ? <Link href={path} className={linkStylexProps.className} style={linkStyle}>
          {props.icon ? React.cloneElement(props.icon, {
        ...{
          className: "x1lliihq x1fr90bg xpz6ql4 x1db2dqx x15dgqpb"
        }
      }) : null}
          <span className="xuxw1ft xb3r6kr xlyipyv xack27t">{label}</span>
          {icon}
        </Link> : <button type="button" className={linkStylexProps.className} style={linkStyle} onClick={() => setActive(x => !x)}>
          {props.icon ? React.cloneElement(props.icon, {
        ...{
          className: "x1lliihq x1fr90bg xpz6ql4 x1db2dqx x15dgqpb"
        }
      }) : null}
          <span className="xuxw1ft xb3r6kr xlyipyv xack27t">{label}</span>
          {icon}
        </button>}
    </div>;
}